import React from 'react';

const ErrorState = ({ error, onRetry }) => {
  return (
    <div className="text-center py-12">
      <p className="text-error">{error}</p>
      <button 
        onClick={onRetry}
        className="mt-4 px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary/90"
      >
        Try Again
      </button>
    </div>
  );
};

export default ErrorState;